<template>
  <div>
      <b-row>
      <b-colxx>
        <b-card class="mb-4">

          <b-row>
            <b-colxx sm="12" md="6" lg="3" xl="3">
              <template v-for="(item , i) in qrcodeProps">
              <div class="form-group has-float-label newMul-li">
                  <div>
                    <ul>
                      <li>구매자</li>
                      <li>{{item.buyerName}}</li>
                    </ul>
                  </div>
                  <div>
                    <ul>
                      <li>상품명</li>
                      <li>{{item.orderItems[i].goodsName}}</li>
                    </ul>
                  </div>
                   <div>
                    <ul>
                      <li>옵션명</li>
                      <li>{{item.orderItems[i].optionName}}</li>
                    </ul>
                  </div>
                  <div>
                    <ul>
                      <li>쿠폰번호</li>
                      <li>{{item.orderItems[i].itemNo}}</li>
                    </ul>
                  </div>
                  <div>
                    <ul>
                      <li>유효기간</li>
                      <li>
                        {{
                          item.orderItems[i].availableTo >= toDay ? item.orderItems[i].availableTo.substr(0, 10) + " " + item.orderItems[i].availableTo.substr(11, 8) : "만료"
                        }}
                      </li>
                    </ul>
                  </div>
                  <!-- {{item.orderItems[i].goodsType}} -->
                  <div v-if="item.orderItems[i].goodsType === 'MoneyCoupon'">
                    <ul>
                      <li class="lastNewDivLi">
                        <div v-if="item.orderItems[i].usableAmount > 0 &&item.orderItems[i].itemStatus == 'Available' " variant="primary" size="sm">
                            <h2>사용 가능 금액 : <span style="color:#c11314">{{usePay | currency}}원</span></h2>
                            <b-input-group>
                              <b-form-input :max="item.orderItems[i].usableAmount" v-model="useAmount" placeholder="사용할 금액을 입력해주세요" type="number" ></b-form-input>
                            </b-input-group>
                            <b-button class="mt-2" variant="primary" @click="useProcess(item.orderItems[i])">사용처리</b-button>
                        </div>
                        <b-button v-else
                            variant="primary" size="sm" class="completion">사용완료
                        </b-button>
                      </li>
                    </ul>
                  </div>
                  <div v-else>
                    <ul v-if="(new Date(item.orderItems[i].availableTo) > new Date())&& !item.orderItems[i].consumedDate">
                        <li><b-button class="mb-2" variant="primary" @click="useMobileCoupon(item.orderItems[i].itemNo,item.orderNo,item.orderItems[i].itemStatus,item.orderItems[i].goodsType)">사용처리</b-button></li>
                    </ul>
                    <ul v-else>
                      <li><b-button class="completion mb-2" variant="primary" >사용완료</b-button></li>
                    </ul>
                  </div>
              </div>
              </template>
            </b-colxx>
          </b-row>

        </b-card>
      </b-colxx>
      </b-row>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapMutations
} from "vuex";
import {currencyFilter } from "../../utils";
import api from '../../constants/api'

export default {
  filters : {...currencyFilter},
  data(){
    return{
      toDay: this.$moment().format("YYYY-MM-DD"),
      useAmount:null,
      items: [],
      usePay: "",
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName'])
  },
  created(){
    this.getUsePay();
  },
    methods:{
      getUsePay(){
        this.qrcodeProps.forEach((v) => {
            v.orderItems.forEach((value, index) => {
                this.usePay = value.usableAmount
                console.log(this.usePay)
            },this)
          })
      },
      useMobileCoupon(item,oder,itemStatus,goodsType){
        var data = this.selectUseCoupon(itemStatus,goodsType,item,oder);
        const orders = data.orders         //체크된 옵션의 orderNo, itemNo[]
        if(confirm('사용처리 하시겠습니까?')) {
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.consumeMobileCoupons)
            const params =
            {
                "memo": "사용 처리 함",
                "orders": orders,
            }

            console.log(oder,item)
            this.$http.post(reqURL, params, {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
            }).then(res => {
            if(res.data.code === "OK") {
                alert('사용처리 되었습니다.');
                this.$emit('hideModar')


            } else {
                throw 400
            }
            }).catch(err => {
            alert(err.response.data.message);

            })
        }
      },
      selectUseCoupon(itemStatus,goodsType,item,oder) {
      let data = {}
      let selected = true
      let count = 0

      const orders = []

          let flag = false;
          const orderNo = oder //주문번호

          let itemNoArr = []
          // console.log(s,d)
            if(goodsType == "MobileCoupon" && itemStatus == "Available") {
                flag = true
                itemNoArr.push(item)
            }
          if(flag) {
            orders.push({
              "orderNo": orderNo,
              "itemNos": itemNoArr
            })
          }

      data.orders = orders

      console.log(data.orders);
      return data
    },
      useProcess(coupon){
        if( this.useAmount === null || this.useAmount < 1 ){
          alert('사용하실 금액을 입력해주세요.')
          return
        }
        if( confirm( this.useAmount + ' 원을 사용 처리 하시겠습니까?' ) ) {
          let orderNo = ''; //선택주문번호
          const itemNo = coupon.itemNo //선택쿠폰번호

          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.useMoneyCoupon)

          this.qrcodeProps.forEach((v) => {
            v.orderItems.forEach(function(value, index) {
              if(value.itemNo == itemNo) {
                orderNo = v.orderNo
              }
            })
          })

          const params =
            {
              memo: "금액권 사용 처리함",
              orderNo: orderNo,
              itemNo: itemNo,
              useAmount: this.useAmount,
              currencyCode: "KRW"
            }

          // console.log(params);

          this.$http.post(reqURL, params, {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if(res.data.code === "OK") {
              alert('사용처리 되었습니다.');
              const uus = this.usePay - this.useAmount;
              this.usePay = uus;
              this.useAmount = '';

            } else {
              throw 400
            }
          }).catch(err => {
            alert(err.response.data.message);
          })
        }

      }
    },
    props: {
		qrcodeProps: {
			type: Array,
			required: true,
		},
	},
}
</script>

<style>

</style>